import React from "react"
import { Card, CardBody, Row, Col, Badge } from "reactstrap"
import { Link } from "react-router-dom"

const BusinessInsights = () => {
  // Dummy data for business insights - replace with real API data
  const businessData = {
    totalBusinessUsers: 1250,
    verifiedBusinesses: 980,
    pendingVerifications: 45,
    claimRequests: 8,
    monthlyGrowth: 15.2,
    topBusinessCategories: [
      { name: "Technology", count: 245, growth: "+12%" },
      { name: "Education", count: 189, growth: "+8%" },
      { name: "Healthcare", count: 156, growth: "+18%" },
      { name: "Retail", count: 134, growth: "+5%" },
      { name: "Food & Beverage", count: 98, growth: "+22%" }
    ],
    revenueMetrics: {
      totalRevenue: 125000,
      monthlyRecurring: 45000,
      averagePerBusiness: 125,
      conversionRate: 78.4
    }
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h4 className="card-title mb-0">Business Insights</h4>
          <Link to="/business-user-list" className="btn btn-sm btn-outline-primary">
            Manage Businesses
          </Link>
        </div>

        <Row className="mb-4">
          <Col sm={6} md={3}>
            <div className="text-center p-3 border rounded">
              <h4 className="text-primary mb-1">{businessData.totalBusinessUsers.toLocaleString()}</h4>
              <p className="text-muted mb-0 font-size-13">Total Businesses</p>
              <Badge color="success" className="badge-soft mt-1">
                +{businessData.monthlyGrowth}%
              </Badge>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center p-3 border rounded">
              <h4 className="text-success mb-1">{businessData.verifiedBusinesses}</h4>
              <p className="text-muted mb-0 font-size-13">Verified</p>
              <small className="text-muted">
                {((businessData.verifiedBusinesses / businessData.totalBusinessUsers) * 100).toFixed(1)}% rate
              </small>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center p-3 border rounded">
              <h4 className="text-warning mb-1">{businessData.pendingVerifications}</h4>
              <p className="text-muted mb-0 font-size-13">Pending</p>
              <Link to="/kyc" className="btn btn-xs btn-outline-warning mt-1">
                Review
              </Link>
            </div>
          </Col>
          <Col sm={6} md={3}>
            <div className="text-center p-3 border rounded">
              <h4 className="text-info mb-1">{businessData.claimRequests}</h4>
              <p className="text-muted mb-0 font-size-13">Claims</p>
              <Link to="/Claim-requests" className="btn btn-xs btn-outline-info mt-1">
                Process
              </Link>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <h6 className="mb-3">Top Business Categories</h6>
            <div className="table-responsive">
              <table className="table table-sm table-borderless">
                <tbody>
                  {businessData.topBusinessCategories.map((category, index) => (
                    <tr key={index}>
                      <td className="py-2">
                        <div className="d-flex align-items-center">
                          <div className={`avatar-xs rounded-circle bg-primary d-flex align-items-center justify-content-center me-2`}>
                            <span className="text-white font-size-10">{index + 1}</span>
                          </div>
                          <span className="font-size-14">{category.name}</span>
                        </div>
                      </td>
                      <td className="py-2 text-end">
                        <span className="font-weight-bold">{category.count}</span>
                      </td>
                      <td className="py-2 text-end">
                        <Badge color="success" className="badge-soft font-size-11">
                          {category.growth}
                        </Badge>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>

          <Col md={6}>
            <h6 className="mb-3">Revenue Metrics</h6>
            <div className="space-y-3">
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">Total Revenue</span>
                <span className="font-weight-bold text-success">
                  ${businessData.revenueMetrics.totalRevenue.toLocaleString()}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">Monthly Recurring</span>
                <span className="font-weight-bold text-primary">
                  ${businessData.revenueMetrics.monthlyRecurring.toLocaleString()}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                <span className="text-muted">Avg. per Business</span>
                <span className="font-weight-bold text-info">
                  ${businessData.revenueMetrics.averagePerBusiness}
                </span>
              </div>
              <div className="d-flex justify-content-between align-items-center py-2">
                <span className="text-muted">Conversion Rate</span>
                <Badge color="success" className="badge-soft">
                  {businessData.revenueMetrics.conversionRate}%
                </Badge>
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default BusinessInsights